<section class="testimonials px-8">
  <p class="mt-8">
    Stali klienci szczególnie cenią sobie:
  </p>
  <ul class="mt-8 mb-8 list-disc pl-10 ">
    <li>doradztwo w zaprojektowaniu lady chłodniczej</li>
    <li>pomoc w pierwszym ułożeniu pojemników i podestów w ladzie</li>
    <li>to, że dokładnie badamy potrzeby klientów i je spełniamy</li>
    <li>naszą dostępność</li>
    <li>bardzo szeroki wybór pojemników (ok. 200 rodzajów)</li>
  </ul>
</section>